export default __webpack_public_path__ + "icons/whaleBgSpot-e2724e.svg";